// @flow
import {CommonActions} from '@react-navigation/native';
import React, {Component} from 'react';
import {StyleSheet, View} from 'react-native';
import {Frame, FullButton} from '../../../../components/common';
import I18n from '../../../../lib/i18n';
import Navigation from '../../../../lib/navigation';
import theme from '../../../../theme-config';
import WizzeeLog from '../../../../lib/wizzeeLog';

class VouchersFrame extends Component<Props> {
  styles = getStyles();

  onPressGoToVouchers = () => {
    if (this.props.parentScreen) {
      this.props.setVoucherDetailsComeFrom(this.props.parentScreen);
    } else {
      this.props.setVoucherDetailsComeFrom(this.props.comeFrom ?? '');
    }

    Navigation.dispatch(CommonActions.navigate({name: 'manageVouchers'}));
  };

  render() {
    const {comeFrom, parentScreen} = this.props;

    WizzeeLog.log('VoucherFrame comeFrom: ', comeFrom);
    WizzeeLog.log('VoucherFrame parentScreen: ', parentScreen);

    const styles = this.styles;

    const changePlanStyle = comeFrom && comeFrom === 'changeplan';
    const subscriptionStyle =
      comeFrom && (comeFrom === 'subscription' || comeFrom === 'signup');
    const topupStyle = comeFrom && comeFrom === 'topup';
    const boosterStyle = parentScreen && parentScreen === 'booster';
    const activationStyle = comeFrom && comeFrom === 'activation';

    let properStyle = null;
    if (boosterStyle) {
      properStyle = styles.bossterContainer;
    } else if (
      activationStyle ||
      changePlanStyle ||
      topupStyle ||
      subscriptionStyle
    ) {
      properStyle = styles.containerNoMarginTop;
    }

    return (
      <View style={properStyle}>
        <Frame
          title={I18n.t('Dashboard.ManageVouchers.title')}
          isLoadingForToggling={false}
          onToggleFolded={this.onPressGoToVouchers}
          toggleTitle={I18n.t('Dashboard.ManageVouchers.toggleTitle')}
          isLoading={false}
          style={[!changePlanStyle || !topupStyle ? styles.container : null]}>
          <View>
            <FullButton
              text={I18n.t('Dashboard.ManageVouchers.discoverPlans')}
              onPress={this.onPressGoToVouchers}
              style={styles.button}
              textStyle={styles.buttonText}
              iconName={'invitefriend'}
              iconSize={22}
            />
          </View>
        </Frame>
      </View>
    );
  }
}

type Props = {
  comeFrom?: string,
  setVoucherDetailsComeFrom: Function,
};

const getStyles = () => {
  return StyleSheet.create({
    container: {
      paddingTop: 8,
      paddingBottom: 20,
      paddingHorizontal: 16,
      marginBottom: 8,
    },
    bossterContainer: {
      paddingTop: 8,
      marginTop: 8,
      marginBottom: 8,
      marginLeft: 10,
      marginRight: 10,
      borderRadius: 5,
      borderWidth: 0.8,
      borderColor: theme.secondaryColor,
    },
    containerNoMarginTop: {
      paddingTop: 8,
      marginBottom: 30,
      marginLeft: 10,
      marginRight: 10,
      borderRadius: 5,
      borderWidth: 0.8,
      borderColor: theme.secondaryColor,
    },
    frameContent: {
      justifyContent: 'center',
      flex: 1,
    },
    button: {
      alignSelf: 'center',
      width: '100%',
      marginTop: 15,
      marginBottom: -10,
      paddingRight: 20,
      paddingLeft: 20,
      borderRadius: 5,
      borderWidth: 0.8,
      borderColor: theme.primaryColor,
    },
    buttonText: {
      fontSize: 16,
      fontWeight: '500',
    },
  });
};

export default VouchersFrame;
